//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NCGroupBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.LayoutCiBuilder.js";
let d=[[[1,"BlankOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"CheckOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"GeometryCiBuilder",0,"CAM.GeometryCiBuilder",0],[1,"LayoutCiBuilder",0,"CAM.LayoutCiBuilder",0],[0,"MachineComponent",1,0],[0,"PartMaterialBuilder",1,"NXObject",1],[1,"PartOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"PhysicalWorkpieceState",1,0],[0,"TrimOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0]],[[[],"GetMaterial",{R_:{libRef:''}},0,0],[["libRef"],"SetMaterial",{},1,0],[["libRef","name","description","code","hardness"],"GetMaterialData",{},0,0]],[]];
SPLM.CAM.FeatureGeomBuilder = class extends SPLM.CAM.NCGroupBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeatureGeomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;